const seo = {
  description:
    "Workay adalah platform kesehatan finansial untuk karyawan dan membantu perusahaan anda mempertahankan pekerja terbaik.",
  title: "Workay | Gaji Instan Karyawan Perusahaan dan Rewards",
  keywords: `Workay, workay, karyawan, bisnis, produktivitas, rewards, Bisnis, Finansial, finansial, perusahaan, untuk, Produktivitas, Perusahaan, Kesehatan,`,
  image: "https://assetpublic.workay.id/logo-workay.png",
};

export default seo;